<template>
    <div>
        <div v-if="isDoorNotCertifed() && !getNrOfValuesByCharacteristic('CUST_MM_TUER_MASS_SYM') < 2" class="body-2 lighter-text red--text">
            {{$t('achtungDoorWing')}}
        </div>
        <v-radio-group v-model="selectedDoorSymmetry" row>
            <template>
                <v-row>
                    <v-col cols="6" class="py-2"
                        v-for="(valueDefinition, index) in getCharacteristicAndValues('CUST_MM_TUER_MASS_SYM').values"
                        :key="index">
                        <v-radio :label="valueDefinition.description" :value="valueDefinition.value"
                            :disabled="getNrOfValuesByCharacteristic('CUST_MM_TUER_MASS_SYM') < 2"
                            @change="addCharacterisitc({ characteristic: getCharacteristicAndValues('CUST_MM_TUER_MASS_SYM'), valueDefinition: valueDefinition });">
                        </v-radio>
                    </v-col>
                </v-row>
            </template>
        </v-radio-group>
        
        <div class="mb-6" v-show="isSymetric === true && isNein === false">
            <div class="font-weight-bold mb-3">{{$t('masseFurGeflugelSym')}}</div>
            <div>
                <div class="body-2 pb-2" style="">
                    {{$t('symDescription')}}</div>
                <v-text-field class="unit-text-field" v-model="trafficDoorWidth" :disabled="true" dense outlined hide-details suffix="mm">
                </v-text-field>
            </div>
        </div>

        <div class="mb-6" v-show="isSymetric === false && isNein === false">
            <div class="font-weight-bold mb-3">{{$t('masseFurGeflugelAsym')}}</div>
            <div>
                <div class="body-2 pb-2" style="">
                    {{$t('asymDescription')}}</div>
                <v-text-field class="unit-text-field" v-model="trafficDoorWidth" dense outlined hide-details suffix="mm">
                </v-text-field>
            </div>
        </div>

        <div class="mb-4">
            <div class="font-weight-bold mb-3">{{$t('zertifizierterBereich')}}</div>
            <div class="d-flex mb-5">
                <div class="mr-4" style="width:50%;">
                    <div class="body-2 pb-2" style="">{{$t('minimaleStehlflugelbreite')}}</div>
                    <v-text-field class="unit-text-field" disabled style="" dense outlined hide-details :value="doorLeafSizesData.minStandingLeafWidth" suffix="mm">
                    </v-text-field>
                </div>
                <div class="" style="width:50%;">
                    <div class="body-2 pb-2" style="">{{$t('maximaleStehlflugelbreite')}}</div>
                    <v-text-field class="unit-text-field" disabled style="" dense outlined hide-details :value="doorLeafSizesData.maxStandingLeafWidth" suffix="mm">
                    </v-text-field>
                </div>
            </div>
        </div>
        
    </div>
    <!-- <div>        
        <label class="label-desc top-label">Achtung: Geh- bzw. Stehflügel nicht im zertifiziertem Bereich!</label>
        <h1 class="title">Geh-und Stehflugel</h1>
        <div class="group-wrapper">
            <label class="input-label">Teilung 2-flugelige Tur</label>
            <div class="btn-group btn-group-toggle c-btn-group-toggle" data-toggle="buttons">
                <label v-for="(valueDefinition, index) in getCharacteristicAndValues('CUST_MM_TUER_MASS_SYM').values" :key="index" 
                @click="addCharacterisitc({ characteristic: getCharacteristicAndValues('CUST_MM_TUER_MASS_SYM'), valueDefinition: valueDefinition });changeSelectedSymetry(valueDefinition.value) " 
                :class="{ 'btn':true, 'btn-secondary':true, 'active': checkRadioValue(getCharacteristicAndValues('CUST_MM_TUER_MASS_SYM').code, valueDefinition.value),
                 'c-disabled': getNrOfValuesByCharacteristic('CUST_MM_TUER_MASS_SYM') < 2 }"
                >
                    <div class="radio-btn">
                        <span></span>
                    </div>
                    <input type="radio" :name="valueDefinition.value" autocomplete="off"> {{ valueDefinition.description }}
                </label>
            </div>
        </div>
        <div class="group-wrapper margin-bottom">
            <div class="symetric" v-show="isSymetric === true">
                <label class="input-label">Maße fur Geflugel bei symmetrischer Teilung</label>
                <div class="input-group disabled">
                    <div class="input-group-prepend">
                        <span class="input-group-text" id="inputGroup-sizing-default">Durchgangslichtebreite des Geflugels bei 90 bei sym. Teilung</span>
                    </div>
                    <input type="text" class="form-control" v-model="trafficDoorWidth" aria-label="Default" placeholder="Breite Gehflugel"
                        disabled aria-describedby="inputGroup-sizing-default">
                    <span class="post">mm</span>
                </div>
            </div>
            <div class="asymetric" v-show="isSymetric === false">
                <label class="input-label">Maße fur Geflugel bei asymmetriscsher Teilung </label>
                <div class="input-group">
                    <div class="input-group-prepend">
                        <span class="input-group-text" id="inputGroup-sizing-default">Durchgangslichtebreite des Geflugels bei 90 bei asym. Teilung</span>
                    </div>
                    <input type="text" class="form-control" v-model="trafficDoorWidth" aria-label="Default" placeholder="Breite Gehflugel"
                        aria-describedby="inputGroup-sizing-default">
                    <span class="post">mm</span>
                </div>
            </div>
        </div>
        <label class="input-label margin-top">Zertifizierter Bereich 2-fluglige Tur</label>
        <div class="disabled-inputs">
            <div class="input-group disabled">
                <div class="input-group-prepend">
                    <span class="input-group-text" id="inputGroup-sizing-default">Minimale Stehlflugelbreite</span>
                </div>
                <input type="text" class="form-control" aria-label="Default" disabled
                    aria-describedby="inputGroup-sizing-default" value="300">
                <span class="post">mm</span>
            </div>
            <div class="input-group disabled">
                <div class="input-group-prepend">
                    <span class="input-group-text" id="inputGroup-sizing-default">Maximale DGLB Gehflugel</span>
                </div>
                <input type="text" class="form-control" aria-label="Default" disabled
                    aria-describedby="inputGroup-sizing-default" value="1200">
                <span class="post">mm</span>
            </div>
        </div>
    </div> -->
</template>
<script>
    import Vue from 'vue';
    import {
        DoorConfiguration
    } from '../../../configurator/DoorConfiguration';
    import {
        Characteristic,
        ValueDefinition,
        MapCharacteristicAndValue
    } from '../../../configurator/types';
    import {
        mapGetters
    } from 'vuex';
    import {
        mapActions
    } from 'vuex';
    import {parseToGermanFloat, parseFloatFromGermanFloat} from '../../../services/ParserService';

    export default Vue.extend({
        name: 'DoorWingSide',
        props: {
            doorLeafSizesData: Object
        },
        data() {
            return {
                parseToGermanFloat: parseToGermanFloat,
                parseFloatFromGermanFloat: parseFloatFromGermanFloat,
                measureContext: DoorConfiguration.Measure,
                isSymetric: true,
                isNein: false
                // trafficDoorWidthValue: 0
            }
        },
        computed: {
            ...mapGetters('configuratorModule', ['getCurrentDoorConfiguration',
                'getRegisteredCharacteristicsValue'
            ]),
            ...mapGetters('measureModule', ['getCharacteristicAndValues', 'getNrOfValuesByCharacteristic',
                'checkRadioValue', 'getTrafficDoor'
            ]),
            selectedDoorSymmetry:{
                get: function () {
                    const _this = this;
                    const selectedSymmetry = _this.getRegisteredCharacteristicsValue("CUST_MM_TUER_MASS_SYM",
                        this.measureContext).value.value;
                    this.isSymetric = selectedSymmetry === 'SY' ? true : false;
                    this.isNein = selectedSymmetry === 'NEIN' ? true : false;
                    return selectedSymmetry;
                },
                set: function(newValue){
                    const _this = this;
                    let trafficDoor = _this.getTrafficDoor;

                    if (newValue === "SY") {
                        this.isSymetric = true;
                        trafficDoor.WidthAsym = 0;
                    } else {
                        this.isSymetric = false;
                    }

                    _this.valueAddCharacteristic({
                            characteristicValue: _this.getCharacteristicAndValues("KTU_MM_DGLB_90_GEHFLUEGEL"),
                            value: this.trafficDoorWidth
                        });
                    _this.setTrafficDoor(trafficDoor);
                    // this.updateabsenkdichtungValues();
                }
            },
            trafficDoorWidth: {
                // getter
                get: function () {
                    // this.trafficDoorWidthValue = this.getRegisteredCharacteristicsValue('KTU_MM_DGLB_90_GEHFLUEGEL', this.measureContext).value.value
                    // return this.trafficDoorWidthValue;

                    const _this = this;
                    let trafficDoorWidth = 0;
                    if (this.selectedDoorSymmetry === 'SY') {
                        trafficDoorWidth = _this.getTrafficDoor.WidthSym;
                    } else if (this.selectedDoorSymmetry == 'ASY') {
                        trafficDoorWidth = _this.getTrafficDoor.WidthAsym;
                    } else {
                        trafficDoorWidth = _this.getTrafficDoor.Width;
                    }

                    return this.parseToGermanFloat(trafficDoorWidth);
                },
                // setter
                set: function (newValue) {
                    newValue = this.parseFloatFromGermanFloat(newValue);
                    // this.trafficDoorWidthValue = newValue;
                    // this.valueAddCharacteristic({ characteristicValue: this.getCharacteristicAndValues('KTU_MM_DGLB_90_GEHFLUEGEL'), value: newValue });

                    const _this = this;
                    let trafficDoor = _this.getTrafficDoor;
                    if (this.selectedDoorSymmetry === 'SY') {
                        trafficDoor.WidthSym = _this.getRegisteredCharacteristicsValue(
                            'KTU_MM_DGLB_90_GEHFLUEGEL', this.measureContext).value.value;
                    } else if (this.selectedDoorSymmetry == 'ASY') {
                        trafficDoor.WidthAsym = newValue;
                        _this.valueAddCharacteristic({
                            characteristicValue: _this.getCharacteristicAndValues(
                                "KTU_MM_DGLB_90_GEHFLUEGEL"),
                            value: newValue
                        });
                    } else {
                        trafficDoor.Width = 0;
                        _this.valueAddCharacteristic({
                            characteristicValue: _this.getCharacteristicAndValues(
                                "KTU_MM_DGLB_90_GEHFLUEGEL"),
                            value: 0
                        });
                    }
                    _this.setTrafficDoor(trafficDoor);
                    this.updateabsenkdichtungValues();
                    // _this.valueAddCharacteristic({ characteristicValue: _this.getCharacteristicAndValues("KTU_MM_DGLB_90_GEHFLUEGEL"), value: newValue });
                }
            },
            getTurblattSym: function() {
                return this.getRegisteredCharacteristicsValue('CUST_MM_TUER_MASS_SYM', DoorConfiguration.Measure).value.value;
            }
        },
        watch: {
            getTurblattSym(getTurblattSym) {
                this.updateabsenkdichtungValues();
            },
        },
        methods: {
            ...mapActions('configuratorModule', ['updateDoorConfiguration']),
            ...mapActions('measureModule', ['addCharacterisitc', 'valueAddCharacteristic', 'setTrafficDoor', 'updateabsenkdichtungValues']),
            // changeSelectedSymetry(value) {
            //     if (value === "SY") {
            //         this.isSymetric = true;
            //     } else {
            //         this.isSymetric = false;
            //     }
            // },
            isDoorNotCertifed: function(){
                const tuerblattbreite = this.getRegisteredCharacteristicsValue('KTU_MM_TUERBLATTBREITE_STEHFLG', this.measureContext).value.value;
                if(!this.minValue(parseFloat(tuerblattbreite), this.doorLeafSizesData.minStandingLeafWidth))
                    return true
                else 
                    return !this.maxValue(parseFloat(tuerblattbreite), this.doorLeafSizesData.maxStandingLeafWidth);
            },
            minValue(value,min) {
                return (value || "") >= min || false;
            },
            maxValue(value,max) {
                return (value || "") <= max || false;
            },
        },
        beforeMount() {
            let trafficDoorWidth = this.getTrafficDoor;
            if(trafficDoorWidth.WidthSym === 0)
                trafficDoorWidth.WidthSym = this.getRegisteredCharacteristicsValue('KTU_MM_DGLB_90_GEHFLUEGEL', this.measureContext).value.value;
            this.setTrafficDoor(trafficDoorWidth);
        },
    });
</script>
<style scoped>

</style>